import React from 'react';
import { Divider } from 'antd';
import s from './s.module.less';
import TimezoneOperationhours from 'components/Calendar/TimezoneOperationhours';

const TimezoneOperationhoursCard = () => {
    return (
        <div className={s.wrap}>
            <div className="bg-white rounded-lg px-7 pt-3 py-7">
                <div className={`${s.title} text-gray-800 text-xl font-medium`}>Time zone and operation hours</div>
                <Divider />
                <TimezoneOperationhours />
            </div>
        </div>
    );
};

export default TimezoneOperationhoursCard;
